import React, { createContext, useState } from "react";

interface DetailsByCustomerActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: any;
  setElement: (element: any) => void;  
}

export const DetailsByCustomerActionContext = createContext<DetailsByCustomerActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: null,
  setElement: () => {},  
});

interface DetailsByCustomerActionProviderProps {
  children: React.ReactNode;
}

export const DetailsByCustomerActionProvider: React.FC<DetailsByCustomerActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(null);  

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,    
  };
  return (
    <DetailsByCustomerActionContext.Provider value={value}>      
      {children}
    </DetailsByCustomerActionContext.Provider>
  );
};
